import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";
import _Object$values from "@babel/runtime-corejs3/core-js-stable/object/values";
import React from 'react';
import Schema from 'async-validator';
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import merge from 'lodash/merge';
import set from 'lodash/set';
import devwarning from '../../_utils/devwarning';
export var INTERNAL_HOOK_KEY = '__KD_INTERNAL_FORM_HOOK__';
var FormStore = /*#__PURE__*/_createClass(function FormStore() {
  var _this = this;
  _classCallCheck(this, FormStore);
  this.isMounted = false;
  this.defaultValues = {};
  this.store = {};
  this.fields = {};
  this.errorMessages = {};
  this.callbacks = {};
  this.getForm = function () {
    return {
      getFieldValue: _this.getFieldValue,
      getFieldsValue: _this.getFieldsValue,
      getDefaultValue: _this.getDefaultValue,
      getFieldError: _this.getFieldError,
      getFieldsError: _this.getFieldsError,
      resetFields: _this.resetFields,
      setFieldValue: _this.setFieldValue,
      setFieldsValue: _this.setFieldsValue,
      validateFields: _this.validateFields,
      submit: _this.submit,
      getInternalHooks: _this.getInternalHooks
    };
  };
  this.getInternalHooks = function (key) {
    if (key !== INTERNAL_HOOK_KEY) {
      devwarning(false, 'Form', '`getInternalHooks` is internal usage.');
      return null;
    }
    _this.isMounted = true;
    return {
      dispatch: _this.dispatch,
      setDefaultValues: _this.setDefaultValues,
      setCallbacks: _this.setCallbacks,
      registerField: _this.registerField,
      deleteField: _this.deleteField
    };
  };
  this.warningUnhooked = function () {
    !_this.isMounted && devwarning(false, 'Form', 'Instance created by `useForm` is not connected to any Form element. Forget to pass `form` prop?');
  };
  /**
   * Dispath. 用于 Field 触发数据变更
   * @param action
   */
  this.dispatch = function (action) {
    _this.warningUnhooked();
    var namePath = action.namePath;
    switch (action.type) {
      case 'updateValue':
        _this.updateValue(namePath, action.value);
        break;
      case 'validateField':
        _this.validateFields([namePath]);
        break;
      default:
        break;
    }
  };
  this.setDefaultValues = function (values) {
    _this.warningUnhooked();
    if (!values) return;
    var copyDefaultValues = cloneDeep(_this.defaultValues);
    var copyValues = cloneDeep(values);
    _this.defaultValues = _extends(_extends({}, copyDefaultValues), copyValues);
    _this.store = merge(_this.store, values);
  };
  this.getDefaultValue = function (name) {
    _this.warningUnhooked();
    return get(_this.defaultValues, name);
  };
  this.getFieldValue = function (name) {
    _this.warningUnhooked();
    return get(_this.store, name);
  };
  this.setFieldValue = function (name, value) {
    _this.warningUnhooked();
    _this.setFieldsValue(_defineProperty({}, name, value));
  };
  this.getFieldsValue = function (namePathList) {
    _this.warningUnhooked();
    if (!namePathList) {
      return cloneDeep(_this.store);
    }
    var fieldsValue = {};
    namePathList.forEach(function (name) {
      fieldsValue[name] = get(_this.store, name);
    });
    return fieldsValue;
  };
  this.setFieldsValue = function (store) {
    _this.warningUnhooked();
    if (!store) return;
    var prevStore = cloneDeep(_this.store);
    _this.store = merge(_this.store, store);
    _this.notifyObservers(prevStore, null, 'externalUpdateValue');
  };
  this.getFieldError = function (name) {
    _this.warningUnhooked();
    return get(_this.errorMessages, name);
  };
  this.getFieldsError = function (namePathList) {
    _this.warningUnhooked();
    if (!namePathList) {
      return cloneDeep(_this.errorMessages);
    }
    var result = {};
    namePathList.forEach(function (name) {
      result[name] = _this.errorMessages[name];
    });
    return result;
  };
  this.getRules = function (namePathList) {
    _this.warningUnhooked();
    var list = cloneDeep(namePathList);
    if (!list) {
      list = _Object$keys(_this.fields);
    }
    var rules = {};
    list.forEach(function (name) {
      var _a, _b;
      var current = _this.fields[name].current;
      if ((_a = current === null || current === void 0 ? void 0 : current.meta) === null || _a === void 0 ? void 0 : _a.rules) {
        rules[name] = cloneDeep((_b = current === null || current === void 0 ? void 0 : current.meta) === null || _b === void 0 ? void 0 : _b.rules);
      }
    });
    return _Object$keys(rules).length === 0 ? null : rules;
  };
  this.setCallbacks = function (callbacks) {
    _this.warningUnhooked();
    _this.callbacks = cloneDeep(callbacks);
  };
  this.resetFields = function () {
    _this.warningUnhooked();
    var prevStore = cloneDeep(_this.store);
    // 重置时，无默认值的 field value 不能设置为 undefined
    // 部分控件 undefined 的话不会生效
    var newStore = {};
    for (var key in _this.store) {
      newStore[key] = _this.defaultValues[key] ? _this.defaultValues[key] : '';
    }
    _this.store = newStore;
    _this.errorMessages = {};
    _this.notifyObservers(prevStore, null, 'reset');
  };
  this.updateValue = function (name, value) {
    _this.warningUnhooked();
    var prevStore = cloneDeep(_this.store);
    set(_this.store, name, value);
    var trigger = get(_this.fields, [name, 'meta', 'trigger']);
    // 默认是 onChange 触发校验
    if (trigger === undefined || trigger === 'onChange' || _includesInstanceProperty(trigger).call(trigger, 'onChange')) {
      _this.validateFields([name]);
    } else {
      _this.notifyObservers(prevStore, [name], 'updateValue');
    }
    var onValuesChange = _this.callbacks.onValuesChange;
    if (onValuesChange) {
      onValuesChange(_defineProperty({}, name, value), cloneDeep(_this.store));
    }
  };
  this.registerField = function (name, field) {
    _this.warningUnhooked();
    _this.fields[name] = field;
  };
  this.deleteField = function (name) {
    _this.warningUnhooked();
    Object.hasOwnProperty.call(_this.fields, name) && delete _this.fields[name];
    Object.hasOwnProperty.call(_this.errorMessages, name) && delete _this.errorMessages[name];
    Object.hasOwnProperty.call(_this.store, name) && delete _this.store[name];
  };
  this.validateFields = function (namePathList) {
    _this.warningUnhooked();
    var rules = _this.getRules(namePathList);
    // 没有设置校验规则的情况下，不做校验
    if (!rules) return _Promise.resolve({
      values: cloneDeep(_this.store)
    });
    var validator = new Schema(rules);
    var validatePromise = new _Promise(function (resolve, reject) {
      validator.validate(_this.store).then(function () {
        resolve({
          values: cloneDeep(_this.store)
        });
      }).catch(function (_ref) {
        var errors = _ref.errors,
          fields = _ref.fields;
        // eslint-disable-next-line
        console.log(errors);
        // eslint-disable-next-line  prefer-promise-reject-errors
        reject({
          errors: errors,
          errorInfos: {
            values: cloneDeep(_this.store),
            fields: fields
          }
        });
      });
    });
    /**
     * 内部校验用
     */
    validatePromise.then(function () {
      namePathList === null || namePathList === void 0 ? void 0 : namePathList.forEach(function (name) {
        _this.errorMessages[name] && delete _this.errorMessages[name];
      });
      _this.notifyObservers(_this.store, namePathList || [], 'validateFinish');
    }).catch(function (_ref2) {
      var errorInfos = _ref2.errorInfos;
      if (!namePathList) {
        _this.errorMessages = {};
      }
      var _errorInfos$fields = errorInfos.fields,
        fields = _errorInfos$fields === void 0 ? {} : _errorInfos$fields;
      _Object$keys(fields).forEach(function (name) {
        _this.errorMessages[name] = fields[name][0].message;
      });
      _this.notifyObservers(_this.store, namePathList || [], 'validateFinish');
    });
    return validatePromise;
  };
  this.submit = function () {
    _this.warningUnhooked();
    _this.validateFields().then(function (values) {
      var onFinish = _this.callbacks.onFinish;
      if (onFinish) {
        try {
          onFinish(values);
        } catch (err) {
          console.error(err);
        }
      }
    }).catch(function (_ref3) {
      var errorInfos = _ref3.errorInfos;
      var onFinishFailed = _this.callbacks.onFinishFailed;
      if (onFinishFailed) {
        onFinishFailed(errorInfos);
      }
    });
  };
  this.notifyObservers = function (prevStore, namePathList, source) {
    _this.warningUnhooked();
    _Object$values(_this.fields).forEach(function (_ref4) {
      var onStoreChange = _ref4.current.onStoreChange;
      var stores = {
        prev: prevStore,
        curr: _this.store
      };
      onStoreChange(stores, namePathList, source);
    });
  };
});
function useForm(form) {
  var formRef = React.useRef();
  if (!formRef.current) {
    if (form) {
      formRef.current = form;
    } else {
      var formStore = new FormStore();
      formRef.current = formStore.getForm();
    }
  }
  return [formRef.current];
}
export default useForm;